import "core-js/modules/es.array.includes.js";
import { computed } from 'vue';
import $store from '@/store';
// 已缓存的视图
// @ts-ignore
const cachedViews = computed(() => $store.state.tagsView.cachedViews);
// 添加指定路由到视图页签中
export function addTags(route) {
  const {
    name,
    meta: {
      detail
    }
  } = route;
  if (detail) return;
  if (cachedViews.value.includes(name)) return;
  if (name) {
    $store.dispatch('tagsView/addView', route);
  }
}
// 设置组件 name 属性，用于 keep-alive 缓存
export function nameComponent(component, route) {
  if (component && !component.type.name) {
    component.type.name = route.name;
    // fix: 在组建加载前添加 tagView，避免缓存页面直接url进入时，keep-alive 的组件操作异常（不走 activated 和 deActivated 声明周期）
    addTags(route);
  }
  return component;
}